/* eslint-disable */
export const PW_VALIDATOR = {
  passwordSettings: {
    // Minimal password length
    minimalLength: 8,
    // Maximal password length
    maximalLength: 264,
    // Minimum amount of digits [0-9] required
    needNumber: 0,
    // Minimum amount of non-alphanumeric characters required
    needNonAlphanumeric: 0,
    // Minimum amount of uppercase characters required
    needUppercase: 1,
    // Minimum amount of lowercase characters required
    needLowercase: 0
  },

  charIsDigit: function (c) {
    return (c >= "0".charCodeAt(0) && c <= "9".charCodeAt(0));
  },

  charIsLetter: function (c) {
    return c.length === 1 && c.match(/[a-z]/i);
  },

  charIsUpperCase: function (c) {
    return c == c.toUpperCase();
  },

  charIsLowerCase: function (c) {
    return c == c.toLowerCase();
  },

  passwordIsValid: function (password) {
    return this.passwordIsValidWithRules(password, this.passwordSettings)
  },

  passwordIsValidWithRules: function (password, ruleSetProperties) {

    var minLength = ruleSetProperties.minimalLength;
    var maxLength = ruleSetProperties.maximalLength;
    var needNumber = ruleSetProperties.needNumber;
    var needNonAlphanumeric = ruleSetProperties.needNonAlphanumeric;
    var needUppercase = ruleSetProperties.needUppercase;
    var needLowercase = ruleSetProperties.needLowercase;
    var error;

    var length = password.length;
    var countDigits = 0;
    var countNonAlphanumeric = 0;
    var countUppercase = 0;
    var countLowercase = 0;
    var validationResults = new Array();

    for (var i = 0; i < length; i++) {
      var ch = password.charAt(i);
      if (this.charIsDigit(ch)) {
        countDigits++;
        continue;
      }
      if (this.charIsLetter(ch)) {
        if (this.charIsUpperCase(ch)) {
          countUppercase++;
          continue;
        }
        if (this.charIsLowerCase(ch)) {
          countLowercase++;
          continue;
        }
      }
      countNonAlphanumeric++;
    }

    if (minLength > length) {
      validationResults.push("Password requires a minimal length of " + minLength + " characters");
    }
    if (maxLength < length) {
      validationResults.push("Password contains too many characters. A maximum of " + maxLength + " characters is allowed");
    }
    if (countDigits < needNumber) {
      validationResults.push("Password requires at least " + needNumber + " digits");
    }
    if (countUppercase < needUppercase) {
      validationResults.push("Password requires at least " + needUppercase + " uppercase characters");
    }
    if (countLowercase < needLowercase) {
      validationResults.push("Password requires at least " + needLowercase + " lowercase characters");
    }
    if (countNonAlphanumeric < needNonAlphanumeric) {
      validationResults.push("Password requires at least " + needNonAlphanumeric + " non alphanumeric characters");
    }

    if (validationResults.length > 0) {
      error = validationResults.join("\n");
    }
    console.log(validationResults.length === 0);
    var isValid = validationResults.length === 0;
    return {isValid, error};
  }
}


// WEBPACK FOOTER //
// ./src/shared/password-validation.js